// ------ 2019 Updated Checkout - Amanda ------ //
import $ from 'jquery';
jQuery.noConflict();
import { positionSidebar } from "./sidebar";
import { jsEventLog } from "./../utils/log";

export function checkoutFunctionality() {

    // Global Variables
    // Remote URLs for JSON data
    var saveUrl = $('.ffl-data').attr('data-customer-save-remote');
    var getUrl = $('.ffl-data').attr('data-customer-get-remote');
    var preferredId = $('.ffl-search-form').attr('data-preferred-id');

    // Set scroll & resize function for checkout sidebar if sidebar exists
    if ($('#checkout-progress-wrapper').length) {
        positionSidebar();
        $(window).scroll(function () {
            positionSidebar();
        });
        $(window).resize(function () {
            positionSidebar();
        });
    };

    // Load all of the handlebars templates that don't have on click or submit triggers
    if ($('#cart-sidebar-products').length) {
        initHandlebarsLoad();
    }

    // FFL Lookup
    $(".ffl-search-form").on("submit", function (e) {
        e.preventDefault();

        // Sync zip from billing info
        var billingZip = '';
        var $addressSelect = $('#billing-address-select');
        
        // If saved address dropdown exists and a saved address is selected
        if ($addressSelect.length && $addressSelect.val()) {
            var selectedText = $addressSelect.find('option:selected').text();
            if (selectedText) {
                var zipMatch = selectedText.match(/\b(\d{5})\b/);
                if (zipMatch) {
                    billingZip = zipMatch[1];
                }
            }
        } else {
            // New address or using the manual input field
            var $postcodeField = $('#billing\\:postcode');
            if ($postcodeField.length && $postcodeField.val()) {
                billingZip = $postcodeField.val();
            }
        }
        
        // Only default the FFL zip from billing when the field is empty — do not overwrite user input
        if (billingZip) {
            var $fflZipInput = $('#ffl-filter-zip');
            var fflZipVal = ($fflZipInput.val() || '').toString().trim();
            if (!fflZipVal) {
                $fflZipInput.val(billingZip);
            }
        }

        var $this = $(this);
        var searchZip = $('input[id="ffl-filter-zip"]').val();
        var searchDistance = $("select#ffl-filter-radius").val();
        var searchName = $('input[id="ffl-filter-name"]').val();
        var searchSort = $("select#ffl-sort-by").children("option:selected").val();

        // Get data from FFL that's saved to customer's account
        var saveData = {};
        saveData.selectedDealerName = $('.ffl-selected-data').attr('data-selected-name');
        saveData.selectedDealerAddress = $('.ffl-selected-data').attr('data-selected-address');
        saveData.selectedDealerFile = $('.ffl-selected-data').attr('data-selected-file');
        saveData.selectedDealerLat = $('.ffl-selected-data').attr('data-selected-lat');
        saveData.selectedDealerLng = $('.ffl-selected-data').attr('data-selected-lng');
        saveData.selectedDealerId = $('.ffl-selected-data').attr('data-selected-id');
        saveData.selectedDealerPhone = $('.ffl-selected-data').attr('data-selected-phone');

        var searchCriteria = {
            zip: null,
            distance: null,
            name: null,
            sort: null
        }

        if (searchZip !== 'undefined') {
            searchCriteria["zip"] = searchZip;
        }
        if (searchDistance !== 'undefined') {
            searchCriteria["distance"] = searchDistance;
        }
        if (searchName !== 'undefined') {
            searchCriteria["name"] = searchName;
        }

        if (searchSort !== 'undefined') {
            searchCriteria["sort"] = searchSort;
        }

        var searchUrl = $this.attr("action");
        var searchCriteria = "?zip=" + searchCriteria["zip"] + "&distance=" + searchCriteria["distance"] + "&dealer=" + searchCriteria["name"] + "&" + searchCriteria["sort"];

        // Hide search boxes if advanced search button is visible on mobile
        $('.ffl-data').hide();
        $('.modal-ffl-content-overlay').show();
        $('.modal-ffl-content').css('height', '80%');

        $.ajax({
            url: searchUrl + searchCriteria,
            dataType: "json",
        }).done(function (data) {
            if (typeof data.error !== 'undefined' && typeof data.redirect !== 'undefined' && data.redirect.length) {
                window.location.assign(data.redirect);
            }
            data.saveData = saveData;
            //Getting FFL Search Data Using Handlebars
            var fflHeaderTemplate = require('../../templates/fflDataHeader.handlebars');
            var fflHeaderHtml = fflHeaderTemplate(data);
            $('.ffl-data-header-wrapper').html(fflHeaderHtml);
            var fflTemplate = require('../../templates/fflData.handlebars');
            var fflHtml = fflTemplate(data);
            $('#ffl-data').html(fflHtml);
            // Hide search card if it matches the one already selected by the customer
            $('.ffl-card-search').each(function () {
                if ($(this).attr('data-name') == $('.ffl-card-saved').attr('data-name')) {
                    $(this).hide();
                    var markerId = $(this).find('.ffl-card-map').attr('data-markerid');
                    $('.ffl-card-saved .ffl-card-map').attr('data-markerid', markerId);
                    // $('.ffl-card-saved .ffl-card-map').show();
                    return false;
                };
            });
            $('.ffl-data').show();
            // set zip code value initially
            $('input#ffl-filter-zip').val(data.zip);
            // only hide the search section on mobile
            if ($('.ffl-search-button').is(":visible")) {
                $('#search-section').hide();
            } else {
                $('#search-section').show();
            }
            $('.modal-ffl-content-overlay').hide();
            $('.modal-ffl-content').css('height', 'auto');
            //Save Dealer to Customer Account
            saveDealer();
            // Load Google Map within Modal
            initialize2(data);
            // reload map on mobile when toggle is clicked
            $('.search-toggler').click(function (e) {
                initialize2(data);
            });
            // Load Pagination
            function fflPaginationLoad(data) {
                //Getting FFL Pagination Data Using Handlebars
                var fflPagination = require("../../templates/fflPagination.handlebars");
                var fflPaginationHtml = fflPagination({
                    data,
                    pagination: {
                        page: data.currentPage,
                        pageCount: data.pageTotal
                    }
                });
                $("#ffl-pagination").html(fflPaginationHtml);

                $(".pagination li a").on("click", function (e) {
                    e.preventDefault();
                    var $this = $(this);

                    var searchZip = $('input[id="ffl-filter-zip"]').val();
                    var searchDistance = $("select#ffl-filter-radius").val();
                    var searchName = $('input[id="ffl-filter-name"]').val();
                    var searchSort = $("select#ffl-sort-by").children("option:selected").val();
                    var searchPage = $this.attr("data-attribute");

                    // Get data from FFL that's saved to customer's account
                    var saveData = {};
                    saveData.selectedDealerName = $('.ffl-selected-data').attr('data-selected-name');
                    saveData.selectedDealerAddress = $('.ffl-selected-data').attr('data-selected-address');
                    saveData.selectedDealerFile = $('.ffl-selected-data').attr('data-selected-file');
                    saveData.selectedDealerLat = $('.ffl-selected-data').attr('data-selected-lat');
                    saveData.selectedDealerLng = $('.ffl-selected-data').attr('data-selected-lng');
                    saveData.selectedDealerId = $('.ffl-selected-data').attr('data-selected-id');
                    saveData.selectedDealerPhone = $('.ffl-selected-data').attr('data-selected-phone');

                    var searchCriteria = {
                        zip: null,
                        distance: null,
                        name: null,
                        page: null
                    }

                    if (searchZip !== 'undefined') {
                        searchCriteria["zip"] = searchZip;
                    }
                    if (searchDistance !== 'undefined') {
                        searchCriteria["distance"] = searchDistance;
                    }
                    if (searchName !== 'undefined') {
                        searchCriteria["name"] = searchName;
                    }
                    if (searchPage !== 'undefined') {
                        searchCriteria["page"] = searchPage;
                    }

                    var searchUrl = $('.ffl-search-form').attr("action");
                    var searchCriteria = "?zip=" + searchCriteria["zip"] + "&distance=" + searchCriteria["distance"] + "&dealer=" + searchCriteria["name"] + "&" + searchSort + "&" + searchCriteria["page"];

                    $(".ffl-card-loader").show();
                    $.ajax({
                        url: searchUrl + searchCriteria,
                        dataType: "json",
                    }).done(function (data) {
                        data.saveData = saveData;
                        //Getting FFL Search Data Using Handlebars
                        var fflHeaderTemplate = require('../../templates/fflDataHeader.handlebars');
                        var fflHeaderHtml = fflHeaderTemplate(data);
                        $('.ffl-data-header-wrapper').html(fflHeaderHtml);
                        var fflTemplate = require("../../templates/fflData.handlebars");
                        var fflHtml = fflTemplate(data);
                        $("#ffl-data").html(fflHtml);
                        fflPaginationLoad(data);
                        // Hide search card if it matches the one already selected by the customer
                        $('.ffl-card-search').each(function () {
                            if ($(this).attr('data-name') == $('.ffl-card-saved').attr('data-name')) {
                                $(this).hide();
                                var markerId = $(this).find('.ffl-card-map').attr('data-markerid');
                                $('.ffl-card-saved .ffl-card-map').attr('data-markerid', markerId);
                            };
                        });
                        // Reload Google Map
                        initialize2(data);
                        // reload map on mobile when toggle is clicked
                        $('.search-toggler').click(function (e) {
                            initialize2(data);
                        });
                        $(".ffl-card-loader").hide();
                        saveDealer();
                    })
                });
            };
            fflPaginationLoad(data);
            if (typeof data.error !== 'undefined') {
                $('.ffl-data-header h3').text('No results found for your search. Please try another search.');
                $('.modal-ffl-content').css('height', '80%');
                $('#ffl-pagination').hide();
                $(".Toggles").hide();
                $(".ffl-sort").hide();
                $(".ffl-card-saved").hide();
            }
        });
        $('#ffl-pagination').show();
        $("#ffl-modal").addClass("show-modal");
        // ALERT MODAL HAS BEEN POPPED
        jsEventLog(51);
    });

    // Sort By Functionality
    $("select#ffl-sort-by").change(function () {
        var $this = $(this);
        // Make it so that when select dropdowns switch they also have the selected attribute
        $this.children("option:selected").attr("selected", true).siblings().removeAttr("selected");

        var searchZip = $('input[id="ffl-filter-zip"]').val();
        var searchDistance = $("select#ffl-filter-radius").val();
        var searchName = $('input[id="ffl-filter-name"]').val();
        var searchSort = $("select#ffl-sort-by").children("option:selected").val();
        var searchPage = $(".pagination li.active a").attr("data-attribute");

        // Get data from FFL that's saved to customer's account
        var saveData = {};
        saveData.selectedDealerName = $('.ffl-selected-data').attr('data-selected-name');
        saveData.selectedDealerAddress = $('.ffl-selected-data').attr('data-selected-address');
        saveData.selectedDealerFile = $('.ffl-selected-data').attr('data-selected-file');
        saveData.selectedDealerLat = $('.ffl-selected-data').attr('data-selected-lat');
        saveData.selectedDealerLng = $('.ffl-selected-data').attr('data-selected-lng');
        saveData.selectedDealerId = $('.ffl-selected-data').attr('data-selected-id');
        saveData.selectedDealerPhone = $('.ffl-selected-data').attr('data-selected-phone');

        var searchCriteria = {
            zip: null,
            distance: null,
            name: null,
            page: null
        }

        if (searchZip !== 'undefined') {
            searchCriteria["zip"] = searchZip;
        }
        if (searchDistance !== 'undefined') {
            searchCriteria["distance"] = searchDistance;
        }
        if (searchName !== 'undefined') {
            searchCriteria["name"] = searchName;
        }
        if (searchPage !== 'undefined') {
            searchCriteria["page"] = searchPage;
        }

        var searchCriteria = "?zip=" + searchCriteria["zip"] + "&distance=" + searchCriteria["distance"] + "&dealer=" + searchCriteria["name"] + "&" + searchSort + "&" + searchCriteria["page"];
        var searchUrl = $('.ffl-search-form').attr("action");

        $(".ffl-card-loader").show();
        $.ajax({
            url: searchUrl + searchCriteria,
            dataType: "json"
        }).done(function (data) {
            data.saveData = saveData;
            //Getting FFL Search Data Using Handlebars
            var fflHeaderTemplate = require('../../templates/fflDataHeader.handlebars');
            var fflHeaderHtml = fflHeaderTemplate(data);
            $('.ffl-data-header-wrapper').html(fflHeaderHtml);
            var fflTemplate = require("../../templates/fflData.handlebars");
            var fflHtml = fflTemplate(data);
            $("#ffl-data").html(fflHtml);
            // Hide search card if it matches the one already selected by the customer
            $('.ffl-card-search').each(function () {
                if ($(this).attr('data-name') == $('.ffl-card-saved').attr('data-name')) {
                    $(this).hide();
                    var markerId = $(this).find('.ffl-card-map').attr('data-markerid');
                    $('.ffl-card-saved .ffl-card-map').attr('data-markerid', markerId);
                };
            });
            // Reload Google Map
            initialize2(data);
            // reload map on mobile when toggle is clicked
            $('.search-toggler').click(function (e) {
                initialize2(data);
            });
            $(".ffl-card-loader").hide();
            saveDealer();
        });
    });

    // Individual handlebars ajax calls
    function initHandlebarsLoad() {

        var $wrapper = jQuery('#checkout-progress-wrapper');
        var productsUrl = $('#cart-sidebar-products').attr('data-remote');
        var join = productsUrl.indexOf('?') > -1 ? '&' : '?';
        var url = productsUrl + join + "limit=100";

        $.ajax({
            url: url,
            dataType: "json",
            beforeSend: function () {
                $('.loading-overlay').show();
                $wrapper.addClass('is-loading'); 
            },
        }).done(function (data) {
            // Getting Cart Sidebar Totals Using Handlebars
            // var totalsTemplate = require("../../templates/totals.handlebars");
            // var contextualHtml = totalsTemplate(data);
            // $("#sidebar-data").html(contextualHtml);           

            // Getting Modal Products Using Handlebars
            var productsModalTemplate = require("../../templates/productsModal.handlebars");
            var productsModalHtml = productsModalTemplate(data);
            $("#modal-cart-data").html(productsModalHtml);
            // Getting Count and Total for Mobile Cart Using Handlebars
            var mobileTemplate = require("../../templates/mobileCart.handlebars");
            var mobileHtml = mobileTemplate(data);
            $("#mobile-cart").html(mobileHtml);

            
            var productsTemplate = require("../../templates/products.handlebars");
            var productsHtml = productsTemplate(data);
            $("#cart-sidebar-products").html(productsHtml);
            $('.liner').show();
            $('.loading-overlay').hide();
            $wrapper.removeClass('is-loading');
        }).fail(function () {
            $('.loading-overlay').hide();
            $wrapper.removeClass('is-loading');
        });

        // FFL Dealer Card that shows in the Shipping section
        if ($('.show-ffl').length) {
            $.ajax({
                url: getUrl,
                dataType: "json",
            }).done(function (data) {
                // Getting FFL Dealer Card Data Using Handlebars
                var fflCardSavedTemplate = require("../../templates/fflCardSaved.handlebars");
                var fflCardSavedHtml = fflCardSavedTemplate(data);
                $("#ffl-card-saved").html(fflCardSavedHtml);
                cardMap(data);

                if (typeof data.error !== 'undefined') {
                    // Disable the continue button when no FFL is selected or there's an FFL error
                    $("#shippingSave").addClass("disabled").attr("disabled", true);
                    // Only show the error message for certain errors (not "no FFL selected" since that's shown elsewhere)
                    if (data.message !== 'No FFL dealer has been selected') {
                        $('.selected-dealer').after('<div class="alert-dealer-error">' + data.message + '. Please select a different dealer.</div>');
                    }
                }
            });
        }
    };

    var cardMapPollId = null;

    // Reusable function that reloads the single location Google Map
    // Checks if the map div exists before attempting to load it to avoid console error
    function cardMap(data) {
        // Clear any existing poll from a previous call
        if (cardMapPollId) {
            clearInterval(cardMapPollId);
            cardMapPollId = null;
        }

        // Wait for Google Maps API to be available
        function renderMap() {
            if ($('.ffl-list-map').length && document.getElementById('map')) {
                var map3;
                var lat = data.latitude;
                var lng = data.longitude;

                var latlng = new google.maps.LatLng(lat, lng);

                var mapOptions = {
                    zoom: 12,
                    center: latlng,
                    disableDoubleClickZoom: true,
                    fullscreenControl: false
                }
                map3 = new google.maps.Map(document.getElementById('map'), mapOptions);

                var contentString = data.business_name + '<br/>' + '<a target="_blank" href="https://www.google.com/maps/dir/?api=1&destination=' + lat + ', ' + lng + '">Get Directions ></a>';
                var infowindow = new google.maps.InfoWindow({
                    content: contentString
                });

                var marker = new google.maps.Marker({
                    position: latlng,
                    icon: 'https://cdn.classicfirearms.com/skin/frontend/default/classic-arms-19/images/map-marker.png',
                    map: map3,
                });

                marker.addListener('click', function () {
                    infowindow.open(map3, marker);
                });
            }
        }

        if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
            renderMap();
        } else {
            // Poll for Google Maps API to load instead of showing unavailable
            var attempts = 0;
            var maxAttempts = 20; // 10 seconds max
            cardMapPollId = setInterval(function () {
                attempts++;
                if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
                    clearInterval(cardMapPollId);
                    cardMapPollId = null;
                    renderMap();
                } else if (attempts >= maxAttempts) {
                    clearInterval(cardMapPollId);
                    cardMapPollId = null;
                    $('#map').html('<span style="text-align: center; padding-top: 5px;">Map is currently unavailable.</span>');
                }
            }, 500);
        }
    }

    // Large Multi-marker map
    function initialize2(data) {
        if (typeof google !== 'undefined') {
            if (typeof data.items !== 'undefined' && data.items.length) {
                var lat = data.items[0].latitude;
                var lng = data.items[0].longitude;
                // coordinates for customer's already saved FFL dealer
                var savedLat = data.saveData.selectedDealerLat;
                var savedLng = data.saveData.selectedDealerLng;
                var mapOptions = {
                    zoom: 10,
                    center: new google.maps.LatLng(lat, lng),
                };
                var map2 = new google.maps.Map(
                    document.getElementById("map2"),
                    mapOptions
                );

                var infowindow = new google.maps.InfoWindow();
                var marker, i;
                var markers = [];

                function toggleBounce() {
                    if (marker.getAnimation() !== null) {
                        marker.setAnimation(null);
                    } else {
                        marker.setAnimation(google.maps.Animation.BOUNCE);
                    }
                }


                for (i = 0; i < data.items.length; i++) {
                    try {

                        marker = new google.maps.Marker({
                            animation: google.maps.Animation.DROP,
                            position: new google.maps.LatLng(data.items[i].latitude, data.items[i].longitude),
                            icon: 'https://cdn.classicfirearms.com/skin/frontend/default/classic-arms-19/images/map-marker.png',
                            map: map2,
                        });

                        if (data.items[i].latitude == savedLat) {
                            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                                return function () {
                                    var contentString = '<div class="ffl-card ffl-card-status-' + data.saveData.selectedDealerFile + '"><div class="padding-sm"><strong>' + data.saveData.selectedDealerName + '</strong><br/><br/><p class="mb-0 ffl-card-file ffl-card-file-' + data.saveData.selectedDealerFile + '"></p><br/>' + data.saveData.selectedDealerAddress + '<br/><a target="_blank" href="https://www.google.com/maps/dir/?api=1&destination=' + data.saveData.selectedDealerLat + ',' + data.saveData.selectedDealerLng + '">Get Directions ></a></div></div>';
                                    infowindow.setContent(contentString);
                                    infowindow.open(map2, marker);
                                    google.maps.event.addListener(infowindow, 'domready', saveDealer);
                                }
                            })(marker, i))
                        } else {
                            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                                return function () {
                                    var contentString = '<div class="ffl-card ffl-card-status-' + data.items[i].is_license_on_file + '"><div class="padding-sm"><strong>' + data.items[i].business_name + '</strong><br/><br/><p class="mb-0 ffl-card-file ffl-card-file-' + data.saveData.selectedDealerFile + '"></p><br/>' + data.items[i].premise_street + '<br/>' + data.items[i].premise_city + ', ' + data.items[i].premise_state + ' ' + data.items[i].premise_zip + '<br/><a target="_blank" href="https://www.google.com/maps/dir/?api=1&destination=' + data.items[i].latitude + ',' + data.items[i].longitude + '">Get Directions ></a></div><button data-ffl="' + data.items[i].id + '" class="btn-thin ffl-save-dealer">SELECT DEALER</button></div>';
                                    infowindow.setContent(contentString);
                                    infowindow.open(map2, marker);
                                    google.maps.event.addListener(infowindow, 'domready', saveDealer);
                                }
                            })(marker, i))
                        }

                        // Add Markers to array
                        markers.push(marker);

                    } catch (err) {
                        console.log(err);
                    }
                }

                // Fit all of the markers in the view window
                var bounds = new google.maps.LatLngBounds();
                for (var i = 0; i < markers.length; i++) {
                    bounds.extend(markers[i].getPosition());
                }
                map2.fitBounds(bounds);

                // Plot marker for saved dealer
                if (data.saveData) {
                    marker = new google.maps.Marker({
                        animation: google.maps.Animation.DROP,
                        position: new google.maps.LatLng(savedLat, savedLng),
                        icon: 'https://cdn.classicfirearms.com/skin/frontend/default/classic-arms-19/images/map-marker.png',
                        map: map2,
                    });

                    google.maps.event.addListener(marker, 'click', (function (marker, i) {
                        return function () {
                            var contentString = '<div class="ffl-card-status-' + data.saveData.selectedDealerFile + '"><div class="padding-sm"><strong>' + data.saveData.selectedDealerName + '</strong><br/><br/><p class="ffl-card-file"></p><br/>' + data.saveData.selectedDealerAddress + '<br/><a target="_blank" href="https://www.google.com/maps/dir/?api=1&destination=' + data.saveData.selectedDealerLat + ',' + data.saveData.selectedDealerLng + '">Get Directions ></a></div></div>';
                            infowindow.setContent(contentString);
                            infowindow.open(map2, marker);
                            google.maps.event.addListener(infowindow, 'domready', saveDealer);
                        }
                    })(marker, i))

                    markers.push(marker);
                }

                // Trigger a click event on each marker when the corresponding card link is clicked
                $('.ffl-card-map').on('click', function (e) {
                    e.preventDefault();
                    google.maps.event.trigger(markers[$(this).data('markerid')], 'click');
                });

                $('#map2').show();

            } else {
                $('#map2').hide();
            }
        } else {
            //Show the user feedback when Google Maps aren't working so it isn't just a blank square
            $('#map2').html('<span style="text-align: center; padding-top 5px;">Map is currently unavailable.</span>');
        }
    };

    // FFL Save Selected Dealer to Logged in Customer
    function saveDealer() {
        $(".ffl-save-dealer").on("click", function () {
            var $this = $(this);
            // if ($this.closest('.ffl-card').hasClass('ffl-card-status-0')) {
            //     // ALERT MODAL IS POPPED
            //     // jsEventLog(52);
            //     Swal.fire({
            //         title: 'Please Confirm Selection',
            //         text: 'We don\'t have a license on file for your selected dealer. Your dealer will need to provide a copy of their current, valid license before your order can ship.',
            //         confirmButtonText: 'Confirm',
            //         showCancelButton: true,
            //     }).then((result) => {
            //         if (result.isConfirmed) {
            //             // ALERT MODAL IS CONFIRMED
            //             // jsEventLog(53);
            //             // If confirmed, close modal and update dealer with selection
            //             updateFfl($this);
            //             $('.dealerinfo-license').removeClass('d-none');
            //             // ALERT DEALER NOT ON FILE MESSAGE
            //             // jsEventLog(50);
            //         } else if (result.isDismissed) {
            //             // ALERT MODAL IS CANCELLED
            //             // jsEventLog(54);
            //         }
            //     });
            // } else {
            // Update FFL
            updateFfl($this);
            // $('.dealerinfo-license').addClass('d-none');
            // }
        })

        function updateFfl($this) {
            // If confirmed, close modal and update dealer with selection
            $(".ffl-list-checkout").show();
            $(".ffl-list-loader").show();
            $(".ffl-search").hide();
            $(".alert-dealer-error").hide();
            $(".dealer-error").hide();
            // $('.btn-ffl-search').css({
            //     'position': 'absolute',
            //     'top': '-65px',
            //     'text-align': 'left',
            //     'left': '10px'
            // });
            $("#shippingSave").removeClass("disabled").attr("disabled", false);
            // var $this = $(this);
            var dealerData = $this.attr("data-ffl");

            $.ajax({
                url: saveUrl + '?ffl=' + dealerData,
                dataType: "json",
            }).done(function () {
                // Retrieve the Saved Ffl and Refresh Dealer Card
                $.ajax({
                    url: getUrl,
                    dataType: "json",
                }).done(function (data) {
                    // Reloading FFL Dealer Card Data Using Handlebars
                    var fflCardSavedTemplate = require("../../templates/fflCardSaved.handlebars");
                    var fflCardSavedHtml = fflCardSavedTemplate(data);
                    $("#ffl-card-saved").html(fflCardSavedHtml);
                    //Reload Google Map
                    cardMap(data);

                }).then(function (data) {
                    $(".ffl-list-loader").hide();
                    //If the customer is only getting shipped to an ffl, the shipping address needs to be filled with the ffl info - this handles for the page not reloading to fill these fields
                    if (!$('#classic-accessory-shipping').is(':visible')) {
                        $("#shipping\\:company").val(data.business_name);
                        $("#shipping\\:street1").val(data.premise_street);
                        $("#shipping\\:city").val(data.premise_city);
                        $("#shipping\\:postcode").val(data.premise_zip);
                        $("#shipping\\:region").val(data.region);
                        $("#shipping\\:region_id").val(data.region_id).attr('selected', true).attr('disabled', 'disabled').parent().append('<input type="text" id="shipping:region_two" name="shipping[region]" value="' + data.region_id + '" readonly="readonly" placeholder="' + data.region_id + '" style="display: none;"/>');
                        $("#ffl_ship_all_to_dealer").val('13').attr('selected', true);
                        $("#billing\\:use_for_shipping_no").attr('checked', true);
                        $("#billing\\:use_for_shipping_yes").attr('checked', false);
                        if (data.voice_phone != '') {
                            $("#shipping\\:telephone").val(data.voice_phone);
                        }
                        // Populate firstname/lastname from billing (customer's name, not FFL dealer name)
                        // This is required by Magento validation and ensures customer info is captured
                        var billingFirstname = $("#billing\\:firstname").val();
                        var billingLastname = $("#billing\\:lastname").val();
                        
                        if (billingFirstname && billingFirstname.trim() !== '') {
                            $("#shipping\\:firstname").val(billingFirstname);
                        }
                        if (billingLastname && billingLastname.trim() !== '') {
                            $("#shipping\\:lastname").val(billingLastname);
                        }
                    }
                });
            });

            $("#ffl-modal").removeClass("show-modal");
            $('.ffl-data').hide();
            $(".alternate-search-text").show();
        }
    };
};